import ProductForm from './components/ProductForm/ProductForm.vue'
import ServiceForm from './components/ServiceForm/ServiceForm.vue'
import ManualMovementForm from './components/ManualMovementForm/ManualMovementForm.vue'
import LotForm from './components/LotForm/LotForm.vue'

const modals: KwixeoInterface.DynamicModals = [
  {
    key: 'catalog-product-form',
    title: product => product && product.id ? 'catalog.product.editTitle' : 'catalog.product.addTitle',
    component: ProductForm,
    size: 'xl',
    scrollable: false
  },
  {
    key: 'catalog-service-form',
    title: service => service && service.id ? 'catalog.service.editTitle' : 'catalog.service.addTitle',
    component: ServiceForm,
    size: 'xl'
  },
  {
    key: 'catalog-group-form',
    title: group => group && group.id ? 'catalog.group.editTitle' : 'catalog.group.addTitle',
    component: ProductForm,
    attributes: {
      isGroup: true
    },
    size: 'xl'
  },
  {
    key: 'stock-manual-form',
    title: event => event && event.id ? 'catalog.stock.manualEditTitle' : 'catalog.stock.manualAddTitle',
    component: ManualMovementForm,
    size: 'xl',
    scrollable: false
  },
  {
    key: 'catalog-product-lot',
    title: 'catalog.productLot.editTitle',
    component: LotForm,
    size: 'md'
  },
]

export default modals
